import css from './styles.module.scss'
import Img from 'next/legacy/image'
import RichText from 'src/components/typo/RichText/RichText'

const ComparatorsDisclaimer = () => {
  return (
    <div className={css.container}>
      <div className={css.iconsSection}>
        <Img
          src="/assets/icons/warning-icon.svg"
          alt="Disclaimer"
          layout="fixed"
          width={32}
          height={32}
        />
      </div>
      <div className={css.contentSection}>
        <RichText className={css.title} text={'Disclaimer'} />
        <RichText
          className={css.content}
          text={
            "The data on this page is regularly updated, however don’t hesitate to <a href='mailto:marketing@strapi.io'>contact us</a> if you notice a mistake."
          }
        />
      </div>
    </div>
  )
}

export default ComparatorsDisclaimer
